<template>
  <v-form @submit.prevent="submitResponse">
    <single-calculation-ui-component
      :answer.sync="inputs.answer"
      :allow-editing="allowEditing"
      :prepend-text="task.content.config.prependText"
      :append-text="task.content.config.appendText"
      :task-state="taskState"
      :question="task.content.config.question"
    />
  </v-form>
</template>

<script>
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import SingleCalculationUiComponent from '@/tasks/components/task-ui-components/SingleCalculationUiComponent.vue';

export default {
  name: 'SinglePartCalculation',
  components: {SingleCalculationUiComponent},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        answer: '',
      },
    };
  },
};
</script>
